function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFdImgFood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 214 117",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M28.659,60.731l-6.821,0c-0.499,0 -0.904,0.405 -0.904,0.904l0,2.994c0,0.499 0.405,0.904 0.904,0.904l1.131,0l0,4.486l4.56,0l0,-4.486l1.13,0c0.499,0 0.904,-0.405 0.904,-0.904l0,-2.994c0,-0.499 -0.405,-0.904 -0.904,-0.904Z",
    style: {
      fill: "#e6e6e6",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.49,88.129c-4.177,-6.112 -6.312,-13.389 -6.1,-20.789c0.008,-0.353 -0.234,-0.661 -0.577,-0.738l0,-1.294l-7.204,0l0,1.276l-0.099,0c-0.205,0 -0.401,0.086 -0.541,0.236c-0.139,0.151 -0.21,0.353 -0.195,0.557c0.568,7.911 -1.349,15.005 -5.749,21.283c-0.253,0.361 -0.382,0.794 -0.368,1.234l0.787,24.365c0.04,1.129 0.962,2.026 2.091,2.035l16.293,0c1.144,-0.009 2.072,-0.928 2.093,-2.071l0.303,-23.656c0.009,-0.868 -0.247,-1.719 -0.734,-2.438Z",
    style: {
      fill: "#3f3d56",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.237,61.706c0,1.078 -0.873,1.951 -1.951,1.951c-1.077,0 -1.951,-0.873 -1.951,-1.951",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32.911,96.222l-1.973,0c-0.389,-2.525 -2.562,-4.389 -5.118,-4.389c-2.555,0 -4.728,1.864 -5.117,4.389l-1.974,0c-0.424,0 -0.828,0.186 -1.105,0.508c-0.276,0.323 -0.398,0.75 -0.334,1.17l2.143,13.93l12.306,0l2.603,-13.883c0.08,-0.426 -0.034,-0.865 -0.31,-1.198c-0.277,-0.334 -0.688,-0.527 -1.121,-0.527Z",
    style: {
      fill: "#e6e6e6",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.708,73.832l-0.473,18.916l-0.586,23.455l-19.95,0l-0.687,-27.481l-0.372,-14.89l22.068,0Z",
    style: {
      fill: "#e6e6e6",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.174,
    y: 63.769,
    width: 2.825,
    height: 37.428,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.296,88.085l-0.534,26.885l-18.184,0l-0.626,-31.499c3.311,-0.93 6.861,-0.442 9.798,1.348c3.038,1.797 6.452,2.764 9.546,3.266Z",
    style: {
      fill: "#3f3d56",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.487,
    y: 91.111,
    width: 2.592,
    height: 2.592,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.253,
    y: 85.815,
    width: 2.592,
    height: 2.592,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.867,91.563l-2.082,-1.544l1.544,-2.082l2.082,1.545l-1.544,2.081Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.55,96.156l-2.082,-1.544l1.544,-2.082l2.082,1.544l-1.544,2.082Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.605,98.804l-2.082,-1.544l1.544,-2.082l2.082,1.544l-1.544,2.082Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.765,84.248c0,-0.292 -0.237,-0.529 -0.53,-0.529c-0.292,0 -0.529,0.237 -0.529,0.529c0,0.293 0.237,0.53 0.529,0.53c0.293,0 0.53,-0.237 0.53,-0.53Z",
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.996,80.717c0,-0.292 -0.238,-0.529 -0.53,-0.529c-0.292,0 -0.53,0.237 -0.53,0.529c0,0.293 0.238,0.53 0.53,0.53c0.292,0 0.53,-0.237 0.53,-0.53Z",
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192,77.01c0,-0.292 -0.238,-0.53 -0.53,-0.53c-0.292,0 -0.53,0.238 -0.53,0.53c0,0.292 0.238,0.53 0.53,0.53c0.292,0 0.53,-0.238 0.53,-0.53Z",
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.703,58.021c0,32.044 -25.977,58.021 -58.021,58.021c-32.044,0 -58.021,-25.977 -58.021,-58.021c0,-32.044 25.977,-58.021 58.021,-58.021c32.044,0 58.021,25.977 58.021,58.021Z",
    style: {
      fill: "#e6e6e6",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.682,100.371c-20.204,0 -37.594,-14.272 -41.536,-34.088c-3.941,-19.816 6.664,-39.656 25.33,-47.388c18.666,-7.731 40.194,-1.201 51.419,15.598c11.224,16.799 9.019,39.188 -5.267,53.474c-7.925,7.968 -18.708,12.434 -29.946,12.404Zm0,-82.088c-21.912,0 -39.738,17.826 -39.738,39.738c0,21.911 17.826,39.738 39.738,39.738c21.911,0 39.738,-17.827 39.738,-39.738c0,-21.912 -17.827,-39.738 -39.738,-39.738Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M147.726,58.021c0,22.668 -18.376,41.044 -41.044,41.044c-22.668,0 -41.044,-18.376 -41.044,-41.044c0,-22.668 18.376,-41.044 41.044,-41.044c22.668,0 41.044,18.376 41.044,41.044Z",
    style: {
      fill: "#3f3d56",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.159,41.609c-0.847,-1.658 -0.744,-3.643 0.27,-5.205c1.014,-1.562 2.785,-2.464 4.644,-2.365c1.86,0.098 3.526,1.182 4.369,2.843l11.596,22.771c0.847,1.658 0.744,3.643 -0.27,5.205c-1.014,1.562 -2.785,2.463 -4.645,2.365c-1.86,-0.099 -3.525,-1.183 -4.369,-2.843l-11.595,-22.771Z",
    style: {
      fill: "#ff6584",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.452,44.149l-0.535,-1.051c2.671,-2.075 5.807,-3.602 9.283,-4.727l0.535,1.051c-3.762,0.783 -6.962,2.233 -9.283,4.727Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.95,49.054l-0.536,-1.051c2.671,-2.076 5.808,-3.602 9.284,-4.728l0.535,1.051c-3.762,0.783 -6.963,2.233 -9.283,4.728Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.447,53.958l-0.535,-1.051c2.671,-2.075 5.807,-3.602 9.283,-4.727l0.536,1.05c-3.762,0.784 -6.963,2.234 -9.284,4.728Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.945,58.863l-0.535,-1.051c2.671,-2.076 5.807,-3.602 9.283,-4.728l0.535,1.051c-3.762,0.783 -6.963,2.233 -9.283,4.728Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.442,63.767l-0.535,-1.051c2.671,-2.075 5.808,-3.602 9.284,-4.728l0.535,1.051c-3.762,0.784 -6.963,2.234 -9.284,4.728Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M67.459,50.134c-1.309,-2.564 -0.29,-5.704 2.276,-7.01c2.565,-1.306 5.704,-0.284 7.007,2.282l11.596,22.771c1.302,2.563 0.282,5.696 -2.28,7.001c-2.562,1.304 -5.696,0.287 -7.003,-2.273l-11.596,-22.771Z",
    style: {
      fill: "#ff6584",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.752,52.674l-0.535,-1.051c2.671,-2.076 5.808,-3.602 9.284,-4.728l0.535,1.051c-3.762,0.784 -6.963,2.233 -9.284,4.728Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.25,57.578l-0.535,-1.051c2.671,-2.075 5.807,-3.602 9.283,-4.727l0.535,1.051c-3.762,0.783 -6.962,2.233 -9.283,4.727Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.748,62.483l-0.536,-1.051c2.671,-2.076 5.808,-3.602 9.284,-4.728l0.535,1.051c-3.762,0.783 -6.963,2.233 -9.283,4.728Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.245,67.387l-0.535,-1.051c2.671,-2.075 5.807,-3.602 9.283,-4.727l0.536,1.051c-3.763,0.783 -6.963,2.233 -9.284,4.727Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.743,72.292l-0.535,-1.051c2.67,-2.076 5.807,-3.602 9.283,-4.728l0.535,1.051c-3.762,0.783 -6.963,2.233 -9.283,4.728Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M134.107,59.327l0.036,0c2.556,0.021 4.865,-1.525 5.818,-3.897c0.957,-2.421 1.44,-5.003 1.421,-7.606c-0.065,-11.019 -9.029,-20.058 -20.047,-20.211c-9.674,-0.135 -18.104,6.563 -20.159,16.017c-2.055,9.455 2.835,19.048 11.693,22.94c2.324,1.029 5.041,0.525 6.841,-1.268c3.811,-3.831 8.993,-5.982 14.397,-5.975Z",
    style: {
      fill: "#e6e6e6",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.375,46.454c0,-3.707 -3.009,-6.716 -6.716,-6.716c-3.707,0 -6.716,3.009 -6.716,6.716c0,3.707 3.009,6.716 6.716,6.716c3.707,0 6.716,-3.009 6.716,-6.716Z",
    style: {
      fill: "#f9a825"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.853,44.908c0,-0.437 -0.354,-0.792 -0.791,-0.792c-0.436,0 -0.791,0.355 -0.791,0.792c0,0.436 0.355,0.791 0.791,0.791c0.437,0 0.791,-0.355 0.791,-0.791Z",
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.735,45.654c0,-0.437 -0.355,-0.791 -0.791,-0.791c-0.437,0 -0.792,0.354 -0.792,0.791c0,0.437 0.355,0.791 0.792,0.791c0.436,0 0.791,-0.354 0.791,-0.791Z",
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.07,36.708c0,-0.437 -0.354,-0.791 -0.791,-0.791c-0.437,0 -0.791,0.354 -0.791,0.791c0,0.437 0.354,0.791 0.791,0.791c0.437,0 0.791,-0.354 0.791,-0.791Z",
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.048,59.513c0,-0.436 -0.355,-0.791 -0.791,-0.791c-0.437,0 -0.792,0.355 -0.792,0.791c0,0.437 0.355,0.792 0.792,0.792c0.436,0 0.791,-0.355 0.791,-0.792Z",
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.719,35.074c0,-0.437 -0.354,-0.791 -0.791,-0.791c-0.437,0 -0.791,0.354 -0.791,0.791c0,0.436 0.354,0.791 0.791,0.791c0.437,0 0.791,-0.355 0.791,-0.791Z",
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.601,56.715c0,-0.437 -0.355,-0.791 -0.791,-0.791c-0.437,0 -0.792,0.354 -0.792,0.791c0,0.437 0.355,0.791 0.792,0.791c0.436,0 0.791,-0.354 0.791,-0.791Z",
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.384,68.095c0,-0.436 -0.354,-0.791 -0.791,-0.791c-0.437,0 -0.791,0.355 -0.791,0.791c0,0.437 0.354,0.792 0.791,0.792c0.437,0 0.791,-0.355 0.791,-0.792Z",
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.913,69.588c0,-1.648 -1.338,-2.985 -2.985,-2.985c-1.648,0 -2.985,1.337 -2.985,2.985c0,1.647 1.337,2.985 2.985,2.985c1.647,0 2.985,-1.338 2.985,-2.985Z",
    style: {
      fill: "#ff6584"
    }
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.167,69.774c0,1.237 -1.003,2.239 -2.239,2.239c-1.237,0 -2.239,-1.002 -2.239,-2.239",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.689,69.401c0,-1.236 1.002,-2.238 2.239,-2.238c1.236,0 2.239,1.002 2.239,2.238",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M118.995,68.562c0,-0.155 -0.084,-0.28 -0.186,-0.28c-0.103,0 -0.187,0.125 -0.187,0.28c0,0.154 0.084,0.28 0.187,0.28c0.102,0 0.186,-0.126 0.186,-0.28Z",
    style: {
      fill: "#ff6584"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.114,68.189c0,-0.155 -0.083,-0.28 -0.186,-0.28c-0.103,0 -0.187,0.125 -0.187,0.28c0,0.154 0.084,0.279 0.187,0.279c0.103,0 0.186,-0.125 0.186,-0.279Z",
    style: {
      fill: "#ff6584"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.114,70.614c0,-0.154 -0.083,-0.28 -0.186,-0.28c-0.103,0 -0.187,0.126 -0.187,0.28c0,0.154 0.084,0.28 0.187,0.28c0.103,0 0.186,-0.126 0.186,-0.28Z",
    style: {
      fill: "#ff6584"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.234,69.121c0,-0.154 -0.084,-0.279 -0.187,-0.279c-0.103,0 -0.186,0.125 -0.186,0.279c0,0.155 0.083,0.28 0.186,0.28c0.103,0 0.187,-0.125 0.187,-0.28Z",
    style: {
      fill: "#ff6584"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.047,71.174c0,-0.155 -0.083,-0.28 -0.186,-0.28c-0.103,0 -0.187,0.125 -0.187,0.28c0,0.154 0.084,0.279 0.187,0.279c0.103,0 0.186,-0.125 0.186,-0.279Z",
    style: {
      fill: "#ff6584"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.808,70.241c0,-0.155 -0.083,-0.28 -0.186,-0.28c-0.103,0 -0.187,0.125 -0.187,0.28c0,0.154 0.084,0.28 0.187,0.28c0.103,0 0.186,-0.126 0.186,-0.28Z",
    style: {
      fill: "#ff6584"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.883,61.566c0,-1.648 -1.338,-2.985 -2.985,-2.985c-1.648,0 -2.985,1.337 -2.985,2.985c0,1.647 1.337,2.985 2.985,2.985c1.647,0 2.985,-1.338 2.985,-2.985Z",
    style: {
      fill: "#ff6584"
    }
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.137,61.752c0,1.237 -1.003,2.239 -2.239,2.239c-1.237,0 -2.239,-1.002 -2.239,-2.239",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.659,61.379c0,-1.236 1.002,-2.239 2.239,-2.239c1.236,0 2.239,1.003 2.239,2.239",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M124.965,60.54c0,-0.155 -0.084,-0.28 -0.186,-0.28c-0.103,0 -0.187,0.125 -0.187,0.28c0,0.154 0.084,0.279 0.187,0.279c0.102,0 0.186,-0.125 0.186,-0.279Z",
    style: {
      fill: "#ff6584"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.084,60.166c0,-0.154 -0.083,-0.279 -0.186,-0.279c-0.103,0 -0.187,0.125 -0.187,0.279c0,0.155 0.084,0.28 0.187,0.28c0.103,0 0.186,-0.125 0.186,-0.28Z",
    style: {
      fill: "#ff6584"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.084,62.592c0,-0.155 -0.083,-0.28 -0.186,-0.28c-0.103,0 -0.187,0.125 -0.187,0.28c0,0.154 0.084,0.28 0.187,0.28c0.103,0 0.186,-0.126 0.186,-0.28Z",
    style: {
      fill: "#ff6584"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.204,61.099c0,-0.154 -0.084,-0.28 -0.187,-0.28c-0.103,0 -0.186,0.126 -0.186,0.28c0,0.155 0.083,0.28 0.186,0.28c0.103,0 0.187,-0.125 0.187,-0.28Z",
    style: {
      fill: "#ff6584"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.017,63.151c0,-0.154 -0.083,-0.279 -0.186,-0.279c-0.103,0 -0.187,0.125 -0.187,0.279c0,0.155 0.084,0.28 0.187,0.28c0.103,0 0.186,-0.125 0.186,-0.28Z",
    style: {
      fill: "#ff6584"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.779,62.219c0,-0.155 -0.084,-0.28 -0.187,-0.28c-0.103,0 -0.187,0.125 -0.187,0.28c0,0.154 0.084,0.279 0.187,0.279c0.103,0 0.187,-0.125 0.187,-0.279Z",
    style: {
      fill: "#ff6584"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.853,65.67c0,-1.647 -1.338,-2.985 -2.985,-2.985c-1.648,0 -2.985,1.338 -2.985,2.985c0,1.648 1.337,2.985 2.985,2.985c1.647,0 2.985,-1.337 2.985,-2.985Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.107,65.857c0,1.236 -1.003,2.238 -2.239,2.238c-1.237,0 -2.239,-1.002 -2.239,-2.238",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.629,65.483c0,-1.236 1.002,-2.238 2.239,-2.238c1.236,0 2.239,1.002 2.239,2.238",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M130.935,64.644c0,-0.155 -0.084,-0.28 -0.186,-0.28c-0.103,0 -0.187,0.125 -0.187,0.28c0,0.154 0.084,0.28 0.187,0.28c0.102,0 0.186,-0.126 0.186,-0.28Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.054,64.271c0,-0.155 -0.083,-0.28 -0.186,-0.28c-0.103,0 -0.187,0.125 -0.187,0.28c0,0.154 0.084,0.28 0.187,0.28c0.103,0 0.186,-0.126 0.186,-0.28Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.054,66.696c0,-0.154 -0.083,-0.28 -0.186,-0.28c-0.103,0 -0.187,0.126 -0.187,0.28c0,0.155 0.084,0.28 0.187,0.28c0.103,0 0.186,-0.125 0.186,-0.28Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.174,65.204c0,-0.155 -0.084,-0.28 -0.187,-0.28c-0.103,0 -0.186,0.125 -0.186,0.28c0,0.154 0.083,0.279 0.186,0.279c0.103,0 0.187,-0.125 0.187,-0.279Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.987,67.256c0,-0.155 -0.083,-0.28 -0.186,-0.28c-0.103,0 -0.187,0.125 -0.187,0.28c0,0.154 0.084,0.28 0.187,0.28c0.103,0 0.186,-0.126 0.186,-0.28Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.749,66.323c0,-0.154 -0.084,-0.28 -0.187,-0.28c-0.103,0 -0.187,0.126 -0.187,0.28c0,0.154 0.084,0.28 0.187,0.28c0.103,0 0.187,-0.126 0.187,-0.28Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.928,66.043c0,-1.647 -1.338,-2.985 -2.985,-2.985c-1.648,0 -2.985,1.338 -2.985,2.985c0,1.648 1.337,2.985 2.985,2.985c1.647,0 2.985,-1.337 2.985,-2.985Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.182,66.23c0,1.236 -1.003,2.238 -2.239,2.238c-1.237,0 -2.239,-1.002 -2.239,-2.238",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.704,65.857c0,-1.237 1.002,-2.239 2.239,-2.239c1.236,0 2.239,1.002 2.239,2.239",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M116.01,65.017c0,-0.154 -0.084,-0.28 -0.186,-0.28c-0.103,0 -0.187,0.126 -0.187,0.28c0,0.155 0.084,0.28 0.187,0.28c0.102,0 0.186,-0.125 0.186,-0.28Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.129,64.644c0,-0.155 -0.083,-0.28 -0.186,-0.28c-0.103,0 -0.187,0.125 -0.187,0.28c0,0.154 0.084,0.28 0.187,0.28c0.103,0 0.186,-0.126 0.186,-0.28Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.129,67.069c0,-0.154 -0.083,-0.28 -0.186,-0.28c-0.103,0 -0.187,0.126 -0.187,0.28c0,0.155 0.084,0.28 0.187,0.28c0.103,0 0.186,-0.125 0.186,-0.28Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.249,65.577c0,-0.155 -0.084,-0.28 -0.187,-0.28c-0.103,0 -0.186,0.125 -0.186,0.28c0,0.154 0.083,0.28 0.186,0.28c0.103,0 0.187,-0.126 0.187,-0.28Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.062,67.629c0,-0.155 -0.083,-0.28 -0.186,-0.28c-0.103,0 -0.187,0.125 -0.187,0.28c0,0.154 0.084,0.28 0.187,0.28c0.103,0 0.186,-0.126 0.186,-0.28Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.823,66.696c0,-0.154 -0.083,-0.28 -0.186,-0.28c-0.103,0 -0.187,0.126 -0.187,0.28c0,0.155 0.084,0.28 0.187,0.28c0.103,0 0.186,-0.125 0.186,-0.28Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.644,67.349c0,-1.647 -1.337,-2.985 -2.985,-2.985c-1.647,0 -2.985,1.338 -2.985,2.985c0,1.648 1.338,2.985 2.985,2.985c1.648,0 2.985,-1.337 2.985,-2.985Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.898,67.536c0,1.236 -1.002,2.238 -2.239,2.238c-1.236,0 -2.239,-1.002 -2.239,-2.238",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.42,67.163c0,-1.237 1.003,-2.239 2.239,-2.239c1.237,0 2.239,1.002 2.239,2.239",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M122.726,66.323c0,-0.154 -0.083,-0.28 -0.186,-0.28c-0.103,0 -0.187,0.126 -0.187,0.28c0,0.154 0.084,0.28 0.187,0.28c0.103,0 0.186,-0.126 0.186,-0.28Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.846,65.95c0,-0.155 -0.084,-0.28 -0.187,-0.28c-0.103,0 -0.186,0.125 -0.186,0.28c0,0.154 0.083,0.28 0.186,0.28c0.103,0 0.187,-0.126 0.187,-0.28Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.846,68.375c0,-0.154 -0.084,-0.28 -0.187,-0.28c-0.103,0 -0.186,0.126 -0.186,0.28c0,0.155 0.083,0.28 0.186,0.28c0.103,0 0.187,-0.125 0.187,-0.28Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.965,66.883c0,-0.155 -0.084,-0.28 -0.186,-0.28c-0.103,0 -0.187,0.125 -0.187,0.28c0,0.154 0.084,0.28 0.187,0.28c0.102,0 0.186,-0.126 0.186,-0.28Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.779,68.935c0,-0.155 -0.084,-0.28 -0.187,-0.28c-0.103,0 -0.187,0.125 -0.187,0.28c0,0.154 0.084,0.28 0.187,0.28c0.103,0 0.187,-0.126 0.187,-0.28Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.54,68.002c0,-0.154 -0.084,-0.28 -0.187,-0.28c-0.103,0 -0.186,0.126 -0.186,0.28c0,0.155 0.083,0.28 0.186,0.28c0.103,0 0.187,-0.125 0.187,-0.28Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.308,70.521c0,-1.648 -1.337,-2.985 -2.985,-2.985c-1.647,0 -2.985,1.337 -2.985,2.985c0,1.647 1.338,2.985 2.985,2.985c1.648,0 2.985,-1.338 2.985,-2.985Z",
    style: {
      fill: "#ff6584"
    }
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.562,70.707c0,1.237 -1.002,2.239 -2.239,2.239c-1.236,0 -2.239,-1.002 -2.239,-2.239",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.084,70.334c0,-1.236 1.003,-2.239 2.239,-2.239c1.237,0 2.239,1.003 2.239,2.239",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M127.39,69.495c0,-0.155 -0.083,-0.28 -0.186,-0.28c-0.103,0 -0.187,0.125 -0.187,0.28c0,0.154 0.084,0.279 0.187,0.279c0.103,0 0.186,-0.125 0.186,-0.279Z",
    style: {
      fill: "#ff6584"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.51,69.121c0,-0.154 -0.084,-0.279 -0.187,-0.279c-0.103,0 -0.186,0.125 -0.186,0.279c0,0.155 0.083,0.28 0.186,0.28c0.103,0 0.187,-0.125 0.187,-0.28Z",
    style: {
      fill: "#ff6584"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.51,71.547c0,-0.155 -0.084,-0.28 -0.187,-0.28c-0.103,0 -0.186,0.125 -0.186,0.28c0,0.154 0.083,0.28 0.186,0.28c0.103,0 0.187,-0.126 0.187,-0.28Z",
    style: {
      fill: "#ff6584"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.629,70.054c0,-0.154 -0.083,-0.28 -0.186,-0.28c-0.103,0 -0.187,0.126 -0.187,0.28c0,0.155 0.084,0.28 0.187,0.28c0.103,0 0.186,-0.125 0.186,-0.28Z",
    style: {
      fill: "#ff6584"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.443,72.106c0,-0.154 -0.084,-0.279 -0.187,-0.279c-0.103,0 -0.187,0.125 -0.187,0.279c0,0.155 0.084,0.28 0.187,0.28c0.103,0 0.187,-0.125 0.187,-0.28Z",
    style: {
      fill: "#ff6584"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.204,71.174c0,-0.155 -0.084,-0.28 -0.187,-0.28c-0.103,0 -0.186,0.125 -0.186,0.28c0,0.154 0.083,0.279 0.186,0.279c0.103,0 0.187,-0.125 0.187,-0.279Z",
    style: {
      fill: "#ff6584"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.727,59.14c0,-0.436 -0.354,-0.791 -0.791,-0.791c-0.436,0 -0.791,0.355 -0.791,0.791c0,0.437 0.355,0.792 0.791,0.792c0.437,0 0.791,-0.355 0.791,-0.792Z",
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.443,87.859l-19.002,-5.269l0.728,-2.704l19.002,5.27l-0.728,2.703Z",
    style: {
      fill: "#f9a825",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.657,86.956c-6.507,1.245 -13.191,1.245 -19.699,0l0,-2.803c6.522,1.081 13.177,1.081 19.699,0l0,2.803Z",
    style: {
      fill: "#f9a825",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.682,78.547c-6.507,1.246 -13.191,1.246 -19.698,0l0,-2.803c6.521,1.081 13.177,1.081 19.698,0l0,2.803Z",
    style: {
      fill: "#f9a825",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.494,81.911c-6.507,1.245 -13.192,1.245 -19.699,0l0,-2.803c6.522,1.081 13.177,1.081 19.699,0l0,2.803Z",
    style: {
      fill: "#f9a825",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.151,85.087c-6.507,1.246 -13.192,1.246 -19.699,0l0,-2.803c6.522,1.081 13.177,1.081 19.699,0l0,2.803Z",
    style: {
      fill: "#f9a825",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.042,89.737l19.421,-3.262l0.464,2.763l-19.421,3.262l-0.464,-2.763Z",
    style: {
      fill: "#f9a825"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.024,89.597c-5.388,3.884 -11.46,6.716 -17.899,8.348l-1.153,-2.546c6.382,-1.787 12.429,-4.608 17.899,-8.349l1.153,2.547Z",
    style: {
      fill: "#f9a825",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.405,81.099c-5.388,3.884 -11.461,6.716 -17.899,8.348l-1.153,-2.547c6.382,-1.787 12.428,-4.607 17.899,-8.348l1.153,2.547Z",
    style: {
      fill: "#f9a825",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.978,81.268c-5.388,3.884 -11.46,6.716 -17.899,8.348l-1.153,-2.547c6.382,-1.787 12.429,-4.607 17.899,-8.348l1.153,2.547Z",
    style: {
      fill: "#f9a825",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.791,83.452c-5.388,3.884 -11.461,6.716 -17.899,8.348l-1.154,-2.546c6.383,-1.788 12.429,-4.608 17.9,-8.349l1.153,2.547Z",
    style: {
      fill: "#f9a825",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.309,
    y: 77.983,
    width: 0.933,
    height: 0.933,
    style: {
      fill: "#00bf71"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.107,
    y: 94.214,
    width: 0.933,
    height: 0.933,
    style: {
      fill: "#00bf71"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.182,
    y: 77.983,
    width: 0.933,
    height: 0.933,
    style: {
      fill: "#00bf71"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.823,
    y: 89.55,
    width: 0.933,
    height: 0.933,
    style: {
      fill: "#00bf71"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.383,
    y: 84.14,
    width: 0.933,
    height: 0.933,
    style: {
      fill: "#00bf71"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.509,82.203l-1.08,-0.733l0.418,-0.618l1.081,0.734l-0.419,0.617Z",
    style: {
      fill: "#00bf71"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.516,84.255l-1.08,-0.733l0.419,-0.617l1.08,0.733l-0.419,0.617Z",
    style: {
      fill: "#00bf71"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.084,87.8l-1.081,-0.733l0.419,-0.618l1.081,0.734l-0.419,0.617Z",
    style: {
      fill: "#00bf71"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.727,86.709l0.733,-1.08l0.617,0.419l-0.733,1.08l-0.617,-0.419Z",
    style: {
      fill: "#00bf71"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.764,88.015l0.733,-1.08l0.618,0.419l-0.734,1.08l-0.617,-0.419Z",
    style: {
      fill: "#00bf71"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.198,83.538l0.733,-1.081l0.617,0.419l-0.733,1.08l-0.617,-0.418Z",
    style: {
      fill: "#00bf71"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 115.98,
    width: 213.12,
    height: 0.538,
    style: {
      fill: "#3f3d56"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFdImgFood);
export default __webpack_public_path__ + "static/media/fd_img_food.95b79f04.svg";
export { ForwardRef as ReactComponent };